import { useContext, createContext } from 'react';
import { types, castToSnapshot, Instance, onSnapshot } from 'mobx-state-tree';
import AppStore, { appStoreDefault } from 'stores/appStore';
import { createPersistenceService } from '../services/persistenceService';

const RootStore = types
    .model({
        app: AppStore,
    })
    .actions(self => ({
        reset: () => {
            self.app = castToSnapshot(appStoreDefault);
        },
    }));

export type TRootStore = Instance<typeof RootStore>;

export const rootStore = RootStore.create({
    app: castToSnapshot(appStoreDefault),
});

const RootStoreContext = createContext<TRootStore | null>(null);

export const persistenceService = createPersistenceService(rootStore);

let saveTimeoutId: ReturnType<typeof setTimeout> | null = null;
onSnapshot(rootStore, () => {
    if (saveTimeoutId) {
        clearTimeout(saveTimeoutId);
    }

    saveTimeoutId = setTimeout(() => {
        persistenceService.saveState();
    }, 500);
});

export const Provider = RootStoreContext.Provider;

export function useStore(): TRootStore {
    const store = useContext(RootStoreContext);
    if (store === null) {
        throw new Error('Store cannot be null, please add a context provider');
    }
    return store;
}
